<template>
	<div class="drawer">
		<el-drawer size="1100px" :visible.sync="drawerStatus" @close='close' :append-to-body="true" :title="'验收资产'" :wrapperClosable="false" >
			<el-table ref="multipleTable1" :data="tableData" tooltip-effect="dark" size="small" style="width:100%">
				<el-table-column label="编号" >
					<template slot-scope="scope">
						{{scope.row.assetsCode}}
					</template>
				</el-table-column>
				<el-table-column label="名称" >
					<template slot-scope="scope">
						{{scope.row.assetsName}}
					</template>
				</el-table-column>
				<el-table-column label="规格" >
					<template slot-scope="scope">
						{{scope.row.skuName}}
					</template>
				</el-table-column>
				<el-table-column prop="goods_count" label="采购数量" >
					<template slot-scope="scope">
						{{scope.row.count}}
					</template>
				</el-table-column>
				<el-table-column  label="备注">
					<template slot-scope="scope">
						{{scope.row.purchaseRemark}}
					</template>
				</el-table-column>
				<el-table-column  label="验收数量" >
					<template slot-scope="scope">
						{{$public.jian(scope.row.count,scope.row.refuseCount)}}
					</template>
				</el-table-column>
				<el-table-column  label="拒收数量" column-key="tab2key4">
					<template slot-scope="scope">
						<el-input-number v-model="scope.row.refuseCount" controls-position="right" :min="0" :max="scope.row.count" style="width:100px" size="small"></el-input-number>
					</template>
				</el-table-column>
				<el-table-column  label="拒收原因"  width="200px">
					<template slot-scope="scope">
						<el-input v-model="scope.row.reason" type="textarea" :rows="3" style="width:150px;" placeholder="拒收原因"></el-input>
					</template>
				</el-table-column>
			</el-table>
			<div style="height: 40px;width:100%;"></div>
			<div class="btnBox">
				<div class="btnItem" @click="close">取消</div>
				<div class="btnItem submit" @click="submit">确定</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				formLabelWidth:'100px',
				
				tableData:[],
				
			}
		},
		computed:{
			
		},
		props:{
			detail:{
				default:()=>{
					return {}
				}
			}
		},
		mounted(){
			for(let i=0;i<this.detail.purchaseDetailList.length;i++){
				let item = this.detail.purchaseDetailList[i]
				this.$set(item,'refuseCount','')
				this.$set(item,'reason','')
				if(item.purchaseState.id==='1'){
					this.tableData.push(item)
				}
			}
			console.log(this.tableData)
			this.$nextTick(()=>{
				this.drawerStatus = true;
			})
		},
		methods: {
			close(){
				this.$emit('submit',{type:'close'})
			},
			submit(){
				for(let i=0;i<this.tableData.length;i++){
					let item = this.tableData[i]
					if(Number(item.refuseCount)>0){
						if(this.$public.isNull(item.reason)){
							this.$message({
								message: '请输入拒收原因',
								type: 'error'
							});
							return ;
						}else if(item.reason.length<10){
							this.$message({
								message: '请输入拒收原因不能小于10个字符',
								type: 'error'
							});
							return ;
						}
					}
				}
				let list = []
				for(let i=0;i<this.tableData.length;i++){
					let item = this.tableData[i]
					list.push({
						"assetsCode": item.assetsCode,
						"acceptInfo": {
							"officialReceipts": this.$public.jian(item.count,item.refuseCount),
							"rejectionCount": item.refuseCount,
							"rejectionRemark": item.reason
						}
					})
				}
				let params = {
					"purchaseNo": this.detail.purchaseNo,
					"acceptRemark": "",
					"purchaseDetailList": list,
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_zichan+'/api/AssetsPurchase/accept', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.$emit('submit',{type:'success'})
					}
				})
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.form{
				::v-deep .el-form-item{
					margin:5px 0;
					
				}
				
			}
		}
		
	}
	.imgView{
		flex: 1;
		.imgItem{
			position: relative;
			width: 80px; 
			height: 80px;
			margin-right:20px;
			margin-bottom: 10px;
			float: left;
			img{
				width: 100%;
				height: 100%;
			}
			.closeBtn{
				display: block;
				color: red;
				position: absolute;
				top: -10px;
				right: -10px;
				font-size: 20px;
				z-index: 5;
			}
		}
	}
	.btnBox{
		width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
		.btnItem{
			text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
			&.submit{
				background-color: $mainColor;
			}
		}
	}
</style>
